
$(function(){
    $(document).on('click', '.p-sec1__btn--2', function(e) {
        e.preventDefault();
        promokit.coupon();
    });
    $(document).on('click', '.p-sec1__btn--3', function(e) {
        window.open('https://lineage2nshop.plaync.com/lineage2/goods/list?dci=131');
    });

    $(document).on('click', '.p-header__btn--login', function(e){
        e.preventDefault();
        if( window.userData.isLogin ){
            promokit.message({
                type: 'alert',
                message: '이미 로그인 되어있습니다.'
            });
        }
        else{
            promokit.login();
        }

    });
});






let page = promokit.page({
    el:'#container',
    type:'basic',
    game:'lineage2',
    cnb:true,
    caution:{
        el: '#section-caution',
        noRule:true,
    },
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        home:true,
        event:true,
        sns:true,
        theme:'black'
    },

});




// WEBPACK FOOTER //
// ./src/js/welcome.js